import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormData } from '../Utils/form-data';
import { FirmInformationPage } from '../Utils/formdata.models';
import { DynamoService } from '../utils/dynamo.service';
@Component({
  selector: 'app-firm-information',
  templateUrl: './firm-information.component.html',
  styleUrls: ['./firm-information.component.css']
})

export class FirmInformationComponent implements OnInit {

  @ViewChild('fileUploads', { static: false })
  marketingMaterialsInput: ElementRef;
  @ViewChild('trackFileUploads', { static: false })
  trackingRecordsInput: ElementRef;
  MarketingfileSizeflag = false;
  MarketingfiletypeFlag = false;
  TrackingfileSizeflag = false;
  TrackingfiletypeFlag = false;
  fileCountError = false;
  trackRecordCountError = false;
  formOne: FormGroup;
  marketingFileToUpload: Array<any> = Array<any>();
  trackingFileToUpload: Array<any> = Array<any>();
  countries;
  nrSelect = 'usa';
  isDataAvailable = false;
  page = '/investment-strategy-main';
  inputTypeNumbers = [true, true, true];
  filesNameWrongSize: Array<string> = [];
  filesNameWrongExtenstion: Array<string> = [];
  trackRecordNameWrongSize: Array<string> = [];
  trackRecordNameWrongExtenstion: Array<string> = [];
  arrayOfExtensions = ['.exe', '.com', '.js', '.ps', '.ps1', '.html', '.htm', '.bat', '.cmd', '.vbs'];
  constructor(public formData: FormData, private dynamo: DynamoService) { }

  ngOnInit() {
    this.formData.firmInformation = new FirmInformationPage();
    this.formOne = this.formData.firmInformation.getFormGroup();

    this.dynamo.getLookupName('L_Country').subscribe(data => {
      this.countries = data;
      this.isDataAvailable = true;
      this.countries = this.countries.filter(x => x['lookupName'] !== 'United States of America');
    }, error => {
      console.log('Lookup error: ', error);
    });

  }

  proccessFiles(files: FileList) {
    // tslint:disable-next-line: prefer-for-of
    for (let index = 0; index < files.length; index++) {
      const file = files[index];
      const fileExtension = file.name.substring(file.name.lastIndexOf('.'), file.name.length) || file.name;
      if (file.size > 31457280) {
        this.filesNameWrongSize.push(file.name);
      }

      if (this.arrayOfExtensions.indexOf(fileExtension) !== -1) {
        this.filesNameWrongExtenstion.push(file.name);
      }
    }
  }
  makeFilesUploadable(files: FileList) {
    let byteArray;
    for (let index = 0; index < files.length; index++) {
      const file = files[index];
      const fileExtension = file.name.substring(file.name.lastIndexOf('.'), file.name.length) || file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        byteArray = reader.result.toString().split(',')[1];
        this.marketingFileToUpload[index] = {
          title: file.name,
          contenttype: file.type,
          _content: byteArray,
          extension: fileExtension
        };
      };
    }
  }
  handleMarketingFileInput(files: FileList) {
    this.filesNameWrongSize = [];
    this.filesNameWrongExtenstion = [];
    if (files && files.length > 0) {
      if (files.length <= 5) {
        this.fileCountError = false;
        this.proccessFiles(files);
        if (this.filesNameWrongSize.length > 0) {
          this.MarketingfileSizeflag = true;
        } else { this.MarketingfileSizeflag = false; }
        if (this.filesNameWrongExtenstion.length > 0) {
          this.MarketingfiletypeFlag = true;
        } else { this.MarketingfiletypeFlag = false; }
        if (this.MarketingfileSizeflag === false && this.MarketingfiletypeFlag === false) {
          this.MarketingfileSizeflag = false;
          this.MarketingfiletypeFlag = false;
          this.makeFilesUploadable(files);
        } else {
          if (this.marketingMaterialsInput.nativeElement) {
            this.marketingMaterialsInput.nativeElement.value = '';
          }
        }
      } else {
        this.fileCountError = true;
        if (this.marketingMaterialsInput.nativeElement) {
          this.marketingMaterialsInput.nativeElement.value = '';
        }
      }
    }
  }

  proccessTrackRecords(files: FileList) {
    // tslint:disable-next-line: prefer-for-of
    for (let index = 0; index < files.length; index++) {
      const file = files[index];
      const fileExtension = file.name.substring(file.name.lastIndexOf('.'), file.name.length) || file.name;
      if (file.size > 31457280) {
        this.trackRecordNameWrongSize.push(file.name);
      }

      if (this.arrayOfExtensions.indexOf(fileExtension) !== -1) {
        this.trackRecordNameWrongExtenstion.push(file.name);
      }
    }
  }

  makeTrackRecordsUploadable(files: FileList) {
    let byteArray;
    for (let index = 0; index < files.length; index++) {
      const file = files[index];
      const fileExtension = file.name.substring(file.name.lastIndexOf('.'), file.name.length) || file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        byteArray = reader.result.toString().split(',')[1];
        this.trackingFileToUpload[index] = {
          title: file.name,
          contenttype: file.type,
          _content: byteArray,
          extension: fileExtension
        };
      };
    }
  }

  handleTrackRecordsFileInput(files: FileList) {
    // const reader = new FileReader();
    // let byteArray;
    this.trackRecordNameWrongExtenstion = [];
    this.trackRecordNameWrongSize = [];
    if (files && files.length > 0) {
      if (files.length <= 5) {
        this.trackRecordCountError = false;
        this.proccessTrackRecords(files);
        if (this.trackRecordNameWrongSize.length > 0) {
          this.TrackingfileSizeflag = true;
        } else {this.TrackingfileSizeflag = false; }
        if (this.trackRecordNameWrongExtenstion.length > 0) {
          this.TrackingfiletypeFlag = true;
        } else { this.TrackingfiletypeFlag = false;}
        if (this.TrackingfileSizeflag === false && this.TrackingfiletypeFlag === false) {
          this.TrackingfileSizeflag = false;
          this.TrackingfiletypeFlag = false;
          this.makeTrackRecordsUploadable(files)
        } else {
          if (this.trackingRecordsInput.nativeElement) {
            this.trackingRecordsInput.nativeElement.value = '';
          }
        }
      } else {
        this.trackRecordCountError = true;
        if (this.trackingRecordsInput.nativeElement) {
          this.trackingRecordsInput.nativeElement.value = '';
        }
      }
    }
  }

  handleNumbers(numberValue, placeofInput) {
    this.inputTypeNumbers[placeofInput] = !isNaN(numberValue);
    return this.inputTypeNumbers[placeofInput];
  }

  setProps() {
    this.formData.firmInformation.migrateFormData();
    this.formData.firmInformation.marketingFile = this.marketingFileToUpload;
    this.formData.firmInformation.trackRecordFile = this.trackingFileToUpload;
    // console.log(this.formData);
  }
}
